export enum StatusSefazEnum {
  OTIMO = 1,
  BOM = 2,
  LENTO = 3,
  CRITICO = 4
}
